import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-lines-per-function
export function DynamischeStundenbewertung() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  return (
    <>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.label',
        )}
      </span>
      <span className="text-neutrals-900 font-semibold">
        {t(
          'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.zusammenfassung.options.' +
            data.abwesenheiten.allgemein.dynamisch,
        )}
      </span>
      {data.abwesenheiten.allgemein.dynamisch === 'wochenschnitt' && (
        <>
          <span>
            {t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.zusammenfassung.start_abwesenheitszeit.label',
            )}
          </span>
          <span className="text-neutrals-900 font-semibold">
            {`${data.abwesenheiten.allgemein.dynamisch_wochenschnitt_start} ${t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.zusammenfassung.start_abwesenheitszeit.suffix',
            )}`}
          </span>
          <span>
            {t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.zusammenfassung.abwesenheitszeit_limitieren.label',
            )}
          </span>
          <span className="text-neutrals-900 font-semibold">
            {t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.zusammenfassung.abwesenheitszeit_limitieren.options.' +
                (data.abwesenheiten.allgemein
                  .dynamisch_wochenschnitt_limitieren ?? false),
            )}
          </span>
        </>
      )}
      {data.abwesenheiten.allgemein.dynamisch === 'drei_monatsschnitt' && (
        <>
          <span>
            {t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.berechnungsgrundlage.label',
            )}
          </span>
          <span className="text-neutrals-900 font-semibold">
            {t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.berechnungsgrundlage.options.' +
                data.abwesenheiten.allgemein
                  .dynamisch_drei_monatsschnitt_berechnungsgrundlage,
            )}
          </span>
        </>
      )}
    </>
  );
}
